// src/pages/PrivacyPolicy.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
// NavBar and Footer are handled by App.js

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    const sections = t('privacy_policy_page.sections', { returnObjects: true }) || [];

    return (
        <>
            <PageMeta
                title={t('privacy_policy_page.doc_title')}
                description={t('privacy_policy_page.sections.0.text')}
                path="/privacy-policy"
            />
            <StructuredData type="page" page={{ name: t('privacy_policy_page.title'), path: '/privacy-policy' }} />

            <div className="bg-white py-12">
                <div className="max-w-4xl mx-auto py-16 sm:py-24 px-4">
                    <div className="text-left">
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl tracking-tight">
                            {t('privacy_policy_page.title')}
                        </h1>
                        <p className="mt-4 text-sm text-gray-500">{t('privacy_policy_page.last_updated')}</p>
                    </div>

                    <div className="mt-10">
                        {Array.isArray(sections) && sections.map((section, index) => (
                            <div key={index} className="py-8 border-b border-gray-200 last:border-b-0">
                                <h2 className="text-2xl font-bold text-gray-900">{section.title}</h2>
                                {/* --- CLASS UPDATED HERE --- */}
                                <p className="mt-4 text-lg text-gray-600 whitespace-pre-line text-justify">
                                    {section.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;